import Vue from 'vue'
import Router from 'vue-router'
import {baseUrl, Url} from '../config/CONSTANTS';
import store from "../store";

Vue.use(Router);


const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

let client;
let dev = window.navigator.userAgent.toLocaleLowerCase().match(/MicroMessenger/i);
if (dev && dev[0] === 'micromessenger') {
  client = 0
} else {
  client =1
}
const context = require.context('../views', true, /router\.js$/);
const routers = context
  .keys()
  .map(item => context(item).default);
const router = new Router({
  //mode: 'history',
  mode: 'hash',
  routes: [
    { path: '*',
      redirect: '/'
    },
    ...routers
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      localStorage.setItem('top',savedPosition.y)
      return {
        x: 0,
        y: 0
      }
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
});

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title || to.query.title) {
    document.title = to.meta.title || to.query.title;
  }
  if (from.meta.keepAlive) {
    const $content = document.getElementsByClassName('bg')[0];
    const scrollTop = $content ? $content.scrollTop : 0;
    from.meta.scrollTop = scrollTop;
    localStorage.scrollTop = scrollTop
  }
  next();
});

router.afterEach((to, from) => {        //     伸手党福利
  if (window.__wxjs_is_wkwebview == true) {  // IOS
    if (window.entryUrl == '' || window.entryUrl == undefined) {
      var url = `${Url}${to.fullPath}`
      window.entryUrl = url    // 将后面的参数去除
    }
  }else {       // 安卓
    window.entryUrl = '';
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js